import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, withStyles, TextField } from '@material-ui/core';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});
const StorageDestroy = props => {
    let { classes, destroyModalState, translations, handleCloseDanger, handleCloseSafe } = props;

    return (
        <Dialog
            open={destroyModalState.open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{translations['destroy_storage'] || 'Destroy storage'}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {translations['be_carefully'] || 'Be carefully'}.<br />
                    {translations['sure_destroy_storage'] || ' Are you sure you want to destroy storage'}?
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="shredInformation"
                    label="Shred information"
                    type="text"
                    fullWidth
                    required
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseSafe} variant="contained" disabled={props.fetching} className={classes.buttonSafe}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={() => handleCloseDanger(document.getElementById('shredInformation').value)} variant="contained" disabled={props.fetching} className={classes.buttonDanger}>
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, { withTheme: true })(StorageDestroy);